import React from "react";
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Typography,
  Select,
} from "antd";
import { MailOutlined, PhoneOutlined, HomeOutlined } from "@ant-design/icons";
import { FormWrapper, ShipmentForm } from "./style";

const { Title } = Typography;
const { Option } = Select;

const BookShipmentForm = () => {
  const [shipmentForm] = Form.useForm();

  const validatePhone = (rule, value) => {
    if (!value) {
      return Promise.reject("Please input your phone number!");
    }
    if (/[^0-9]/.test(value)) {
      return Promise.reject("Phone number must contain only digits!");
    }
    if (value.length !== 10) {
      return Promise.reject("Phone number must be exactly 10 digits!");
    }
    return Promise.resolve();
  };

  const onFinish = (values) => {
    if (values.productType === "fish") values.productType = "Fish";
    if (values.productType === "tank") values.productType = "Accessories/Tank";
    if (values.productType === "other") values.productType = "Other";

    const formattedValues = {
      ...values,
      fromAddress: {
        fullAddress: values.fromFullAddress,
        city: values.fromCity || 'Not specified',
        pincode: values.fromPincode,
      },
      toAddress: {
        fullAddress: values.toFullAddress,
        city: values.toCity || 'Not specified',
        pincode: values.toPincode,
      },
    };

    const message = `
  *Shipment Details*\n\n
  Full Name: ${formattedValues.fullName}\n
  ${formattedValues.email ? `Email: ${formattedValues.email}\n` : ''}
  Phone: ${formattedValues.phone}\n
  Product Type: ${formattedValues.productType}\n\n
  *From Address*\n
  Full Address: ${formattedValues.fromAddress.fullAddress}\n
  City: ${formattedValues.fromAddress.city}\n
  Pincode: ${formattedValues.fromAddress.pincode}\n\n
  *To Address*\n
  Full Address: ${formattedValues.toAddress.fullAddress}\n
  City: ${formattedValues.toAddress.city}\n
  Pincode: ${formattedValues.toAddress.pincode}\n
  Additional Notes:${formattedValues.additionalNotes || 'None'}
`;

    const whatsappUrl = `https://wa.me/+918300811267?text=${encodeURIComponent(
      message
    )}`;

    window.location.href = whatsappUrl;

    shipmentForm.resetFields();

    alert("Shipment booked successfully! You will be redirected to WhatsApp.");
  };

  return (
    <FormWrapper>
      <ShipmentForm>
        <Title level={2} style={{ textAlign: "center", color: "#00aeef" }}>
          Book Your Pet Shipment
        </Title>
        <Form
          layout="vertical"
          onFinish={onFinish}
          form={shipmentForm}
          style={{ maxWidth: "600px", margin: "auto" }}
        >
          <Form.Item
            label="Full Name"
            name="fullName"
            rules={[
              { required: true, message: "Please enter your full name!" },
            ]}
          >
            <Input
              prefix={<HomeOutlined />}
              placeholder="Enter your full name"
            />
          </Form.Item>
          <Form.Item
            label="Phone Number"
            name="phone"
            rules={[{ required: true, validator: validatePhone }]}
          >
            <Input
              prefix={<PhoneOutlined />}
              placeholder="Enter your phone number"
            />
          </Form.Item>
          <Form.Item
            label="Email"
            name="email"
            rules={[
              {
                type: "email",
                message: "Please enter a valid email!",
              },
            ]}
          >
            <Input prefix={<MailOutlined />} placeholder="Enter your email (optional)" />
          </Form.Item>

        

          <Form.Item
  label="Product Type"
  name="productType"
>
  <Select placeholder="Select pet type">
    <Option value="fish">Fish</Option>
    <Option value="tank">Accesories/Tank</Option>
    <Option value="other">Other</Option>
  </Select>
</Form.Item>

          <Title level={4} style={{ color: "#00aeef", marginBottom: "20px" }}>
            From Address
          </Title>
          <Row gutter={[16, 16]}>
            <Col xs={24}>
              <Form.Item
                label="Full Address"
                name="fromFullAddress"
                rules={[
                  { required: true, message: "Please enter the full address!" },
                ]}
              >
                <Input.TextArea placeholder="Enter full address (street, area, etc.)" rows={3} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="City"
                name="fromCity"
              >
                <Input placeholder="Enter city " />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="Pincode"
                name="fromPincode"
                rules={[
                  { required: true, message: "Please enter the pincode!" },
                ]}
              >
                <Input placeholder="Enter pincode" />
              </Form.Item>
            </Col>
          </Row>

          <Title level={4} style={{ color: "#00aeef", marginBottom: "20px" }}>
            To Address
          </Title>
          <Row gutter={[16, 16]}>
            <Col xs={24}>
              <Form.Item
                label="Full Address"
                name="toFullAddress"
                rules={[
                  { required: true, message: "Please enter the full address!" },
                ]}
              >
                <Input.TextArea placeholder="Enter full address (street, area, etc.)" rows={3} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="City"
                name="toCity"
              >
                <Input placeholder="Enter city " />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="Pincode"
                name="toPincode"
                rules={[
                  { required: true, message: "Please enter the pincode!" },
                ]}
              >
                <Input placeholder="Enter pincode" />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item label="Additional Notes" name="additionalNotes">
            <Input.TextArea placeholder="Enter any special notes for the shipment" />
          </Form.Item>

          <Form.Item style={{ textAlign: "center" }}>
            <Button
              type="primary"
              htmlType="submit"
              style={{
                backgroundColor: "#00aeef",
                padding: "12px 30px",
                fontSize: "18px",
                borderRadius: "5px",
                width: "100%",
              }}
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </ShipmentForm>
    </FormWrapper>
  );
};

export default BookShipmentForm;